var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 216 62",
    viewBox: "0 0 216 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 108,
    x2: 108,
    y1: 0.7975,
    y2: 29.9272
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 108.1326,
    x2: 107.868,
    y1: 2.3458,
    y2: 59.5164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1155,
    stopColor: "#fefeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a5a5"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(11.64 0 0 22.55 -18716.2363 29134.7188)",
    gradientUnits: "userSpaceOnUse",
    x1: 1611.0851,
    x2: 1608.8523,
    y1: -1291.4073,
    y2: -1290.2548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4998d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#4a99d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#42baeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#41c7f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#56c9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5bcae8"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(9.145 0 0 7.7 -14313.6826 10134.1514)",
    gradientUnits: "userSpaceOnUse",
    x1: 1571.2538,
    x2: 1567.1562,
    y1: -1312.1011,
    y2: -1312.1011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#febd11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#faa51a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99c1c"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientTransform: "matrix(15.02 0 0 11.5775 -24664.248 15101.2656)",
    gradientUnits: "userSpaceOnUse",
    x1: 1644.8555,
    x2: 1642.509,
    y1: -1301.3807,
    y2: -1298.3367
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef4049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31e63"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientTransform: "matrix(15.02 0 0 11.5715 -24664.248 15081.9873)",
    gradientUnits: "userSpaceOnUse",
    x1: 1643.0481,
    x2: 1644.0958,
    y1: -1303.3497,
    y2: -1301.9896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#4bba71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#5ebd6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66be69"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m208.001 62h-200.002c-4.418 0-7.999-3.581-7.999-7.999v-46.002c0-4.418 3.581-7.999 7.999-7.999h200.001c4.419 0 8 3.581 8 7.999v46.001c0 4.419-3.581 8-7.999 8z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m208.001 62h-200.002c-4.418 0-7.999-3.581-7.999-7.999v-46.002c0-4.418 3.581-7.999 7.999-7.999h200.001c4.419 0 8 3.581 8 7.999v46.001c0 4.419-3.581 8-7.999 8z",
    fill: "url(#a)",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m208.001 1c3.859 0 6.999 3.14 6.999 6.999v46.001c0 3.859-3.14 6.999-6.999 6.999h-200.002c-3.859.001-6.999-3.139-6.999-6.998v-46.002c0-3.859 3.14-6.999 6.999-6.999zm0-1h-200.002c-4.418 0-7.999 3.581-7.999 7.999v46.001c0 4.419 3.581 8 7.999 8h200.001c4.418 0 7.999-3.581 7.999-7.999v-46.002c.001-4.418-3.58-7.999-7.998-7.999z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m113.627 20.491c-1.402 0-2.584-.49-3.518-1.456-.927-.938-1.444-2.232-1.421-3.553 0-1.41.479-2.603 1.421-3.549.931-.965 2.112-1.456 3.514-1.456 1.386 0 2.568.49 3.518 1.456.942.977 1.421 2.17 1.421 3.549-.015 1.413-.494 2.607-1.421 3.549-.931.974-2.112 1.46-3.514 1.46zm-41.713 0c-1.371 0-2.56-.483-3.534-1.437-.965-.95-1.456-2.151-1.456-3.568s.49-2.618 1.456-3.568c.954-.954 2.143-1.437 3.534-1.437.68 0 1.34.135 1.973.409.622.266 1.128.629 1.502 1.074l.093.112-1.047 1.027-.108-.127c-.591-.703-1.383-1.047-2.429-1.047-.935 0-1.749.332-2.421.989-.676.66-1.02 1.525-1.02 2.572s.344 1.912 1.02 2.572c.672.657 1.487.989 2.421.989.996 0 1.834-.332 2.487-.989.386-.386.626-.927.711-1.61h-3.356v-1.444h4.797l.019.131c.035.243.07.494.07.726 0 1.332-.402 2.41-1.197 3.205-.904.943-2.086 1.421-3.515 1.421zm55.461-.204h-1.479l-4.53-7.249.039 1.305v5.94h-1.479v-9.597h1.688l.046.073 4.26 6.828-.039-1.301v-5.6h1.495zm-24.863 0h-1.498v-8.157h-2.599v-1.444h6.693v1.444h-2.599v8.156h.003zm-5.318 0h-1.494v-9.601h1.495v9.601zm-8.399 0h-1.495v-8.157h-2.599v-1.444h6.693v1.444h-2.599zm-5.04-.016h-5.731v-9.585h5.731v1.444h-4.233v2.634h3.819v1.429h-3.819v2.634h4.233zm27.45-2.228c.668.668 1.479 1.004 2.421 1.004.969 0 1.761-.328 2.421-1.004.657-.657.989-1.518.989-2.557s-.332-1.904-.985-2.557c-.668-.668-1.483-1.004-2.421-1.004-.969 0-1.761.328-2.418 1.004-.657.657-.989 1.518-.989 2.557.001 1.039.33 1.904.982 2.557zm-2.657 15.648c-3.65 0-6.608 2.769-6.608 6.588 0 3.785 2.978 6.588 6.608 6.588 3.65 0 6.608-2.788 6.608-6.588 0-3.819-2.958-6.588-6.608-6.588zm0 10.567c-1.997 0-3.715-1.653-3.715-3.993 0-2.375 1.722-3.993 3.715-3.993 1.997 0 3.715 1.618 3.715 3.993.004 2.355-1.718 3.993-3.715 3.993zm-14.416-10.567c-3.65 0-6.608 2.769-6.608 6.588 0 3.785 2.978 6.588 6.608 6.588 3.65 0 6.608-2.788 6.608-6.588 0-3.819-2.963-6.588-6.608-6.588zm0 10.567c-1.997 0-3.715-1.653-3.715-3.993 0-2.375 1.722-3.993 3.715-3.993 1.997 0 3.715 1.618 3.715 3.993 0 2.355-1.719 3.993-3.715 3.993zm-17.155-8.554v2.788h6.693c-.205 1.564-.722 2.719-1.514 3.51-.981.981-2.495 2.047-5.163 2.047-4.113 0-7.33-3.321-7.33-7.434s3.217-7.434 7.33-7.434c2.221 0 3.839.877 5.04 1.997l1.977-1.978c-1.668-1.599-3.889-2.823-7.002-2.823-5.642 0-10.377 4.596-10.377 10.223 0 5.642 4.731 10.223 10.377 10.223 3.047 0 5.333-.996 7.141-2.873 1.842-1.842 2.425-4.441 2.425-6.538 0-.653-.05-1.24-.154-1.738h-9.446c.003-.005.003.03.003.03zm70.167 2.17c-.552-1.479-2.221-4.198-5.642-4.198-3.391 0-6.21 2.669-6.21 6.588 0 3.7 2.788 6.588 6.538 6.588 3.012 0 4.766-1.842 5.488-2.923l-2.236-1.498c-.741 1.101-1.773 1.823-3.236 1.823-1.479 0-2.514-.672-3.202-1.997l8.809-3.65c0 .005-.309-.733-.309-.733zm-8.982 2.201c-.07-2.545 1.977-3.839 3.441-3.839 1.155 0 2.116.568 2.445 1.394zm-7.156 6.384h2.893v-19.356h-2.893zm-4.751-11.304h-.104c-.653-.776-1.892-1.479-3.476-1.479-3.287 0-6.314 2.893-6.314 6.608 0 3.7 3.012 6.558 6.314 6.558 1.564 0 2.823-.707 3.476-1.498h.104v.946c0 2.514-1.344 3.87-3.51 3.87-1.773 0-2.873-1.274-3.321-2.34l-2.514 1.05c.722 1.738 2.649 3.889 5.832 3.889 3.391 0 6.264-1.997 6.264-6.867v-11.822h-2.734v1.085zm-3.321 9.103c-1.997 0-3.665-1.668-3.665-3.974 0-2.325 1.668-4.009 3.665-4.009 1.977 0 3.51 1.703 3.51 4.009.02 2.305-1.529 3.974-3.51 3.974zm37.754-17.155h-6.917v19.356h2.893v-7.33h4.028c3.202 0 6.349-2.321 6.349-6.005 0-3.685-3.136-6.021-6.353-6.021zm.085 9.323h-4.113v-6.643h4.113c2.167 0 3.391 1.788 3.391 3.321 0 1.518-1.24 3.322-3.391 3.322zm17.862-2.769c-2.101 0-4.267.931-5.163 2.958l2.564 1.066c.552-1.066 1.564-1.429 2.634-1.429 1.498 0 3.012.896 3.047 2.495v.205c-.518-.294-1.653-.741-3.012-.741-2.769 0-5.577 1.514-5.577 4.352 0 2.599 2.271 4.267 4.8 4.267 1.943 0 3.012-.877 3.68-1.892h.104v1.498h2.788v-7.415c.001-3.453-2.563-5.364-5.865-5.364zm-.363 10.601c-.946 0-2.271-.463-2.271-1.653 0-1.498 1.653-2.066 3.062-2.066 1.274 0 1.877.274 2.634.653-.208 1.737-1.676 3.05-3.425 3.066zm16.401-10.188-3.321 8.396h-.104l-3.441-8.396h-3.113l5.163 11.736-2.943 6.523h3.012l7.944-18.259zm-26.037 12.389h2.893v-19.356h-2.893z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.195 11.667c-.448.483-.707 1.22-.707 2.186v34.244c0 .965.259 1.703.722 2.167l.12.104 19.186-19.186v-.429l-19.201-19.19z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.9 37.596-6.399-6.399v-.448l6.399-6.399.139.085 7.569 4.302c2.167 1.22 2.167 3.236 0 4.472l-7.569 4.302z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.039 37.511-6.538-6.538-19.306 19.305c.707.757 1.892.842 3.217.104z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.039 24.434-22.627-12.852c-1.325-.757-2.514-.653-3.217.104l19.306 19.286z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.9 37.372-22.473 12.767c-1.255.722-2.375.672-3.097.015l-.12.12.12.104c.722.653 1.842.707 3.097-.015l22.627-12.852z",
    fill: "#010101",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.608 32.985-7.728 4.387.139.139 7.569-4.302c1.085-.618 1.618-1.429 1.618-2.236-.064.741-.617 1.444-1.598 2.012z",
    fill: "#010101",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.412 11.806 30.196 17.155c.981.552 1.533 1.274 1.618 2.012 0-.807-.533-1.618-1.618-2.236l-30.196-17.155c-2.167-1.24-3.924-.205-3.924 2.271v.224c0-2.48 1.757-3.495 3.924-2.271z",
    fill: "#fff",
    opacity: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnGooglePlay);
export default __webpack_public_path__ + "static/media/Btn_GooglePlay.0c01d986b0625aaef0a0adfa3876a7a2.svg";
export { ForwardRef as ReactComponent };